/* ============================================================
   420 OASIS — Password Page Ambient Particles + Entrance
   Constellation-connected gold dust with cinematic page reveal.
   ============================================================ */

(function () {
  'use strict';

  function triggerEntrance() {
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        document.body.classList.add('is-loaded');
      });
    });
  }

  var canvas = document.getElementById('oasis-particle-canvas');
  if (!canvas) {
    triggerEntrance();
    return;
  }

  var ctx = canvas.getContext('2d');
  var width = 0;
  var height = 0;
  var raf = 0;
  var particles = [];

  var CONFIG = {
    count: 44,
    connectionDistance: 110,
    connectionOpacity: 0.055,
    colors: [
      'rgba(201,168,76,0.55)',
      'rgba(232,201,109,0.35)',
      'rgba(168,133,58,0.42)',
      'rgba(201,168,76,0.24)',
    ],
    minSize: 0.45,
    maxSize: 1.7,
    minSpeedY: -0.18,
    maxSpeedY: -0.05,
    minSpeedX: -0.05,
    maxSpeedX: 0.05,
  };

  function rand(min, max) {
    return Math.random() * (max - min) + min;
  }

  function resize() {
    width = canvas.width = window.innerWidth;
    height = canvas.height = window.innerHeight;
  }

  function makeParticle(randomY) {
    return {
      x: rand(0, width),
      y: randomY ? rand(0, height) : height + rand(10, 40),
      r: rand(CONFIG.minSize, CONFIG.maxSize),
      color: CONFIG.colors[Math.floor(Math.random() * CONFIG.colors.length)],
      vx: rand(CONFIG.minSpeedX, CONFIG.maxSpeedX),
      vy: rand(CONFIG.minSpeedY, CONFIG.maxSpeedY),
      alpha: rand(0.12, 0.7),
      alphaDelta: rand(0.002, 0.007) * (Math.random() > 0.5 ? 1 : -1),
    };
  }

  function init() {
    particles = [];
    for (var i = 0; i < CONFIG.count; i++) {
      particles.push(makeParticle(true));
    }
  }

  function update() {
    for (var i = 0; i < particles.length; i++) {
      var p = particles[i];
      p.x += p.vx;
      p.y += p.vy;
      p.alpha += p.alphaDelta;

      if (p.alpha <= 0.05 || p.alpha >= 0.78) {
        p.alphaDelta *= -1;
      }

      if (p.y < -10) {
        particles[i] = makeParticle(false);
      }
    }
  }

  function drawConnections() {
    var maxDist = CONFIG.connectionDistance;
    var maxDistSq = maxDist * maxDist;

    for (var i = 0; i < particles.length; i++) {
      for (var j = i + 1; j < particles.length; j++) {
        var dx = particles[i].x - particles[j].x;
        var dy = particles[i].y - particles[j].y;
        var distSq = dx * dx + dy * dy;

        if (distSq < maxDistSq) {
          var dist = Math.sqrt(distSq);
          var alpha = (1 - dist / maxDist) * CONFIG.connectionOpacity;
          ctx.strokeStyle = 'rgba(201,168,76,' + alpha + ')';
          ctx.lineWidth = 0.5;
          ctx.beginPath();
          ctx.moveTo(particles[i].x, particles[i].y);
          ctx.lineTo(particles[j].x, particles[j].y);
          ctx.stroke();
        }
      }
    }
  }

  function draw() {
    ctx.clearRect(0, 0, width, height);

    drawConnections();

    for (var i = 0; i < particles.length; i++) {
      var p = particles[i];
      ctx.save();
      ctx.globalAlpha = Math.max(0, Math.min(1, p.alpha));
      ctx.fillStyle = p.color;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fill();
      ctx.restore();
    }
  }

  function loop() {
    update();
    draw();
    raf = window.requestAnimationFrame(loop);
  }

  function boot() {
    resize();
    init();
    loop();
    triggerEntrance();
  }

  window.addEventListener('resize', function () {
    window.cancelAnimationFrame(raf);
    resize();
    init();
    loop();
  });

  document.addEventListener('visibilitychange', function () {
    window.cancelAnimationFrame(raf);
    if (!document.hidden) loop();
  });

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var reset = document.createElement('style');
    reset.textContent = '*,*::before,*::after{transition:none!important;animation:none!important}';
    document.head.appendChild(reset);
    document.body.classList.remove('is-loaded');
    void document.body.offsetHeight;
    document.head.removeChild(reset);
    requestAnimationFrame(function () {
      document.body.classList.add('is-loaded');
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
